module.exports = __webpack_public_path__ + "img/webapps.d0968166.svg";